module.exports = new __parcel__URL__("alertIcon.bd03a77b.svg").toString();